module.exports = __webpack_public_path__ + "static/media/choice2.4ccd374e.png";